// An SVG drawing that fills the width it is given and keeps its aspect ratio (a map, a locator):
// the kit's `Svg` has a fixed pixel width, which is right for icons and flags but not for a figure
// that must fit a phone and a laptop alike. Decorative unless it has a label.
import "./config";

export interface FluidSvgProps {
  viewBox: string;
  /** Announces the drawing as an image; without it the drawing is hidden from assistive technology. */
  label?: string | undefined;
  children: React.ReactNode;
}

export function FluidSvg({ viewBox, label, children }: FluidSvgProps): React.JSX.Element {
  return (
    <svg
      viewBox={viewBox}
      width="100%"
      focusable="false"
      // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
      {...(label === undefined ? { "aria-hidden": true } : { role: "img", "aria-label": label })}
      style={{ display: "block", height: "auto" }}
    >
      {children}
    </svg>
  );
}
